import React from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';
import { event } from '@uhg-abyss/web/tools/event';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { storage } from '@uhg-abyss/web/tools/storage';
import { config } from '@uhg-abyss/web/tools/config';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IllustrationBrand } from '@uhg-abyss/web/ui/IllustrationBrand';
import { useSelector } from 'react-redux';

const Wrapper = styled('div', {});

const Container = styled('div', {
  background: 'rgb(255, 255, 255)',
  display: 'flex',
  borderRadius: '8px',
  border: '1px solid rgb(221, 221, 221)',
  justifyContent: 'left',
  '@screen >= $xs': {
    flexDirection: 'column',
  },
  '@screen >= $xl': {
    flexDirection: 'row',
    height: 'auto',
  },
});

const ContainerSec = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'left',
  '@screen >= $xs': {
    padding: '52px 16px',
    textAlign: 'left',
    width: '100%',
  },
  '@screen >= $xl': {
    padding: '52px',
    // Set width for columns on xl and above
    '&:first-of-type': {
      width: '65%',
    },
    '&:last-of-type': {
      width: '35%',
    },
  },
});

const ContainerSecTitle = styled('h3', {
  color: 'rgb(0, 38, 119)',
  fontSize: '32px ! important',
  fontWeight: 600,
  lineHeight: '40px',
  marginBottom: '16px',
});

const ApiBenefitsList = styled('ul', {
  marginTop: '15px',
  paddingLeft: '20px',
  color: '#333',
  listStyle: 'disc',
});

const ContainerSecDescription = styled('p', {
  color: 'rgb(51, 51, 51)',
  fontSize: '15px',
  fontWeight: 400,
  letterSpacing: 0,
  lineHeight: '24px',
  marginBottom: '27px',
  //  whiteSpace: 'nowrap',
  width: '100%',
});

const ButtonsWrapper = styled('div', {
  marginTop: '24px',
  display: 'flex',
  gap: '16px',
  justifyContent: 'flex-start',
});

export const GetStartedAndContactSection = () => {
  const { navigate } = useRouter();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });

  const signIn = () => {
    const isSignedIn = !!userInfo?.firstName;
    const interactionName = 'getting started';
    const signInText = 'sign in';
    const interactionContext = 'page cta link clicks';
    const exitURL = config('IDENTITY_API_URL');

    if (isSignedIn) {
      event('INTERACTION_EVENT', {
        interactionName,
        interactionValue: signInText,
        interactionContext,
      });
    } else {
      event('EXIT_EVENT', {
        event,
        exitLink: signInText,
        exitURL,
      });
    }

    storage.local.set('IS_SIGN_IN_CLICKED', true);
    if (storage.local.get('IS_SIGNED_OUT')) {
      storage.local.remove('IS_SIGNED_OUT');
    }

    if (process.env.NODE_ENV === 'development') {
      navigate('/welcome');
    } else {
      window.location = `${config('IDENTITY_API_URL')}/login`;
    }
  };
  return (
    <Wrapper>
      <Container>
        <ContainerSec>
          <ContainerSecTitle>Why add APIs to your practice?</ContainerSecTitle>
          <ContainerSecDescription>
            APIs streamline operations, reduce costs, and improve cash flow by
            minimizing phone calls and paperwork. Automated data feeds transfer
            information to and from your preferred systems—on your
            schedule—ensuring smoother workflows with fewer disruptions.
            <ApiBenefitsList>
              <li>
                <strong>Flexible</strong> – Works with a wide range of systems
                and UnitedHealthcare plans.
              </li>
              <li>
                <strong>Automated</strong> – Real-time transactions and seamless
                workflow integration.
              </li>

              <li>
                <strong>Secure</strong> – Strong encryption, password protocols,
                and standardized communication.
              </li>
            </ApiBenefitsList>
            <ButtonsWrapper>
              <Button
                variant="outline"
                onClick={() => {
                  window.open(
                    config('SELF_PACED_USER_GUIDE'),
                    '_blank',
                    'noopener,noreferrer'
                  );
                }}
              >
                {' '}
                Learn more about APIs
              </Button>
              {process.env.NODE_ENV === 'development' ? (
                <Button
                  onClick={signIn}
                  css={{
                    'abyss-button-root': {
                      height: '40px',
                      '@screen < $sm': { width: '100%' },
                    },
                  }}
                >
                  Speak with an API Consultant
                </Button>
              ) : (
                <Button
                  href={`${config('IDENTITY_API_URL')}/login`}
                  onClick={signIn}
                  css={{
                    'abyss-button-root': {
                      height: '40px',
                      '@screen < $sm': { width: '100%' },
                    },
                  }}
                >
                  Speak with an API Consultant
                </Button>
              )}
            </ButtonsWrapper>
          </ContainerSecDescription>
        </ContainerSec>
        <ContainerSec>
          <IllustrationBrand
            illustration="go_digital_screen"
            color="white"
            variant={1}
            size="100%"
          />
        </ContainerSec>
      </Container>
    </Wrapper>
  );
};
